import Angular from "angular";
import Loader from "angular-ecmascript/module-loader";
import Controller from "./loading-indicator.controller";
import LoadingIndicatorService from "./loading-indicator.service";
import IfDataLoadingDirective from "./if-data-loading.directive";

var LoadingIndicatorModule = Angular.module('loading-indicator', [
    IfDataLoadingDirective.name
]);

LoadingIndicatorModule.component('loadingIndicator', {
    controller: Controller,
    bindings: {
        minDuration: '@',
        errorTitle: '@',
        errorMessage: '@'
    },
});

new Loader(LoadingIndicatorModule)
    .load(LoadingIndicatorService);

export default LoadingIndicatorModule;



// WEBPACK FOOTER //
// ./src/modules/core/components/loading-indicator/loading-indicator.js